var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('resize-observer',{on:{"notify":_vm.fit}}),_vm._v(" "),_c('div',{ref:"root",staticClass:"root",attrs:{"id":"diffElement"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }